//折扣系列判断当前可使用的start
$(function(){
  $(".grid-item").each(function(){
    $(this).find(".yh").each(function(){
    	var  isshow=1
        var etime=$(this).attr("etime");
        etime=etime.replace(/-/g,"/");
        var stime=$(this).attr("stime");
        stime=stime.replace(/-/g,"/");
        var dN=new Date()
        var timestampN=dN.getTime();
        if(stime){
            var dS=new Date(stime+" EDT")
            var timestampS=dS.getTime();
            if(timestampS>timestampN){
                   isshow=0;
           }
        }
        if(etime){
            var dE=new Date(etime+" EDT")
            var timestampE=dE.getTime();
            if(timestampN>timestampE){
                $(this).remove();
                isshow=0;
            }
        }
        if(isshow){
          $(this).show();
          return false;
        }
    })
    
  })
})
//折扣系列判断当前可使用的end